import React from "react";
import { CV } from "../components/cv";
import NilsImg from "@/assets/images/nils.png";

export default function CVNilsBroman() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Nils Broman";
  }, []);

  return (
    <CV
      name="Nils Broman"
      photo={NilsImg}
      title="ML Engineer, M.Sc."
      subtitle="Bridges complex machine learning models and solid cloud infrastructure — production-ready AI on GCP, from model to pipeline."
      summary="ML engineer and data science consultant designing and implementing production-ready AI solutions using large language models, cloud-native infrastructure and modern software engineering practices. Responsibilities span backend development, multi-service application architecture, infrastructure as code, CI/CD pipelines and automation, and deployment on Google Cloud Platform. M.Sc. in Engineering Physics with a specialisation in Machine Intelligence from LTH, with strong foundations in mathematics, statistics and programming."
      skills={{
        Programming: ["Python", "SQL", "Java", "MATLAB", "R"],
        "Data Science": [
          "Machine learning",
          "NLP",
          "LLMs",
          "Artificial neural networks",
          "Regression",
          "Image analysis",
          "Computer vision",
        ],
        "Tools & Frameworks": [
          "Git",
          "Docker",
          "Google Cloud",
          "Terraform",
          "GitHub Actions",
          "LaTeX",
        ],
        "Mathematics & Physics": [
          "Statistics",
          "Linear algebra",
          "Complex analysis",
          "Mechanics",
          "Electromagnetism",
          "Quantum mechanics",
          "Optics",
        ],
        Languages: [
          "Swedish (native / C2)",
          "English (fluent / C2)",
          "Spanish (basic / A1)",
        ],
      }}
      experience={[
        {
          role: "ML Engineer / Data Science Consultant",
          company: "MurrAI Skania AB",
          period: "2025 – Present",
          description:
            "Designs and implements production-ready AI solutions using large language models, cloud-native infrastructure and modern software engineering practices.",
          highlights: [
            "Backend development and multi-service application architecture.",
            "Infrastructure as code, CI/CD pipelines and automation.",
            "Deployment and operations on Google Cloud Platform.",
          ],
        },
        {
          role: "Various roles alongside studies",
          company: "Retail, logistics, higher education and hospitality",
          period: "2009 – 2025",
          description:
            "Earlier professional experience across retail (H&M, Expert, Systembolaget), warehouse operations and logistics (H&M), higher education (Lund University), childcare and hospitality.",
        },
      ]}
      education={[
        {
          degree: "M.Sc. Engineering Physics, Machine Intelligence",
          institution: "Faculty of Engineering (LTH), Lund University",
          year: "2025",
        },
      ]}
      otherActivities={{
        title: "Projects & Publications",
        description:
          "Transparent Predictions: Visualizing Mental Health Model Reasoning (Lund University / Minding Health, 2024–2025) — master's thesis developing a reformulated SHAP algorithm computing word- and sentence-level contributions to predictions from paragraph-input models, then using the scores to visualise how different parts of a text influenced the prediction, improving transparency of model reasoning. Biomedical Relation Extraction with Deep Neural Networks (Lund University, 2022) — collaboration with a research group at the Biomedical Centre in Lund on a tool extracting relationships between proteins, DNA and chemicals from scientific literature; fine-tuning of BERT-based models raised the F1 score from 0.65 to 0.86. Also orientation leader and mentor at LTH freshman orientation.",
      }}
    />
  );
}
